module.exports = __webpack_public_path__ + "static/img/Send9.96ed2ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Send9.png
// module id = lyiA
// module chunks = 0